{
  "el": {
    "milestone_unit": {
      "actions": {
        "change_milestone": "Αλλαγή ορόσημου",
        "reset_columns": "Επαναφορά στηλών"
      },
      "labels": {
        "columns": "Στήλες",
        "milestone": "Επίλεξε ένα νέο ορόσημο",
        "no_results": "Δεν βρέθηκαν ακίνητα"
      }
    }
  }
}
